import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import * as actionTypes from '../action-types';
import { getUserWatchers } from '../../watchers.api';
import {
  WatcherEntityItem,
  WatcherSearchQueryEnum,
  WatcherQueryParamsEnum,
  WatcherEntitityId,
} from '../../watchers.types';
import {
  createWatcherWithTracking,
  deleteWatcherWithTracking,
} from './watchers';

const setUserWatchers = (watchers: Array<WatcherEntityItem>) =>
  <const>{
    type: actionTypes.SET_USER_WATCHERS,
    payload: { watchers },
  };

const setUserWatcher = (watcher: WatcherEntityItem) =>
  <const>{
    type: actionTypes.SET_USER_WATCHER,
    payload: { watcher },
  };

const unsetUserWatcher = (uniqueId: string) =>
  <const>{
    type: actionTypes.UNSET_USER_WATCHER,
    payload: { uniqueId },
  };

export const fetchUserWatchers = () => async (
  dispatch: ThunkDispatch<{}, {}, AnyAction>,
) => {
  const { data } = await getUserWatchers();
  dispatch(setUserWatchers(data));
};

export const createUserWatcher = ({
  query,
  uniqueId,
  entityIdParams,
  source,
}: {
  query: string;
  uniqueId: string;
  entityIdParams?: WatcherEntitityId;
  source: string;
}) => async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
  const watcher = await dispatch(
    createWatcherWithTracking(
      [
        {
          type: WatcherSearchQueryEnum.DECISION,
          query: {
            type: WatcherQueryParamsEnum.DECISION,
            query,
            ...entityIdParams,
          },
        },
      ],
      source,
    ),
  );

  if (watcher && watcher.key) {
    dispatch(setUserWatcher({ uniqueId, key: watcher.key }));
  }
};

export const deleteUserWatcher = ({
  uniqueId,
  source,
}: {
  uniqueId: string;
  source: string;
}) => async (
  dispatch: ThunkDispatch<{}, {}, AnyAction>,
  getState: Function,
) => {
  const {
    userWatchers: { map },
  } = getState();
  const watcherKey = map[uniqueId];

  if (watcherKey) {
    await dispatch(deleteWatcherWithTracking(watcherKey, source));
    dispatch(unsetUserWatcher(uniqueId));
  }
};

export type UserWatchersActions = ReturnType<
  typeof setUserWatchers | typeof setUserWatcher | typeof unsetUserWatcher
>;
